import _objectWithoutProperties from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["title", "size", "weight", "fullWidth", "variant", "borderRadius", "isLoading", "transparent", "paddingLeft", "paddingRight", "uppercase", "icon", "hover"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { Fragment } from "react";
import { bool, func, string } from "prop-types";
import Styled from "styled-components";
import { spacing } from "@uprise/spacing";
import { primary, extended, backgrounds } from "@uprise/colors";
import Icons from "@uprise/icons";
var Base = Styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: none;\n    border-radius: 10px;\n    border: none;\n    height: 50px;\n    padding-left: ", ";\n    padding-right: ", ";\n    font-size: ", ";\n    color: ", ";\n    font-family: ", ";\n    cursor: ", ";\n"])), function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.fontSize;
}, primary.purple, function (props) {
  return props.weight === "bold" ? "Proxima Nova Semibold" : "Proxima Nova";
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
});
export var Primary = Styled(Base)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: solid 1px ", ";\n\n    background-color: ", ";\n\n    text-transform: ", ";\n\n    border-radius: ", ";\n    color: ", ";\n    width: ", ";\n    height: ", ";\n\n    \n    &:hover {\n        background-color: ", ";\n    }\n"])), function (props) {
  if (props.disabled) {
    return extended.charcoal.two;
  } else if (props.transparent) {
    return backgrounds.white;
  } else {
    return primary.purple;
  }
}, function (props) {
  if (props.disabled) {
    return extended.charcoal.two;
  } else if (props.transparent) {
    return backgrounds.white;
  } else {
    return primary.purple;
  }
}, function (props) {
  if (props.uppercase) {
    return "uppercase";
  } else {
    return "none";
  }
}, function (props) {
  return props.borderRadius ? props.borderRadius : "10px";
}, function (props) {
  if (props.transparent) {
    return extended.purple.dark;
  } else {
    return backgrounds.white;
  }
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  if (props.transparent && props.hover) {
    return backgrounds.white;
  } else if (props.hover) {
    return extended.purple.dark;
  }
});
export var Secondary = Styled(Base)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n\n    border: solid 1px ", ";\n\n    text-transform: ", ";\n\n    background-color: ", ";\n\n    border-radius: ", ";\n    width: ", ";\n    height: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (props) {
  if (props.disabled) {
    return extended.charcoal.three;
  } else if (props.transparent) {
    return backgrounds.white;
  } else {
    return primary.purple;
  }
}, function (props) {
  if (props.disabled) {
    return extended.charcoal.three;
  } else if (props.transparent) {
    return backgrounds.white;
  } else {
    return primary.purple;
  }
}, function (props) {
  if (props.uppercase) {
    return "uppercase";
  } else {
    return "none";
  }
}, function (props) {
  if (props.transparent) {
    return "transparent";
  } else {
    return backgrounds.white;
  }
}, function (props) {
  return props.borderRadius ? props.borderRadius : "10px";
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  if (props.transparent && props.hover) {
    return "none";
  } else if (props.hover) {
    return extended.purple.five;
  }
});
export var Tertiary = Styled(Primary)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    color: ", ";\n\n    background-color: ", ";\n\n    border: none;\n    border-radius: ", ";\n\n    text-transform: ", ";\n\n    &:hover {\n        background-color: ", ";\n\n        color: ", ";\n    }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  if (props.disabled) {
    return extended.charcoal.two;
  } else if (props.transparent) {
    return backgrounds.white;
  } else {
    return primary.purple;
  }
}, function (props) {
  if (props.disabled) {
    return extended.charcoal.five;
  } else if (props.transparent) {
    return "transparent";
  } else {
    return extended.purple.six;
  }
}, function (props) {
  return props.borderRadius ? props.borderRadius : "10px";
}, function (props) {
  if (props.uppercase) {
    return "uppercase";
  } else {
    return "none";
  }
}, function (props) {
  if (props.transparent && props.hover) {
    return "transparent";
  } else if (props.hover) {
    return extended.purple.five;
  }
}, function (props) {
  if (props.transparent) {
    return backgrounds.white;
  } else {
    return primary.purple;
  }
});
export var TextButton = Styled(Primary)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    background-color: ", ";\n    border: none;\n\tborder-radius: ", ";\n\n    text-transform: ", ";\n\n\t&:hover {\n        background-color: ", ";\n        color: ", ";\n\n    }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, primary.purple, backgrounds.white, function (props) {
  return props.borderRadius ? props.borderRadius : "10px";
}, function (props) {
  if (props.uppercase) {
    return "uppercase";
  } else {
    return "none";
  }
}, backgrounds.white, primary.purple);
export var IconRight = Styled.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\ttop: 1px;\n\tmargin-left: ", ";\n\theight: 10px;\n"])), spacing.s4);
export var Button = function Button(_ref) {
  var title = _ref.title,
      size = _ref.size,
      weight = _ref.weight,
      fullWidth = _ref.fullWidth,
      variant = _ref.variant,
      borderRadius = _ref.borderRadius,
      isLoading = _ref.isLoading,
      transparent = _ref.transparent,
      paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight,
      uppercase = _ref.uppercase,
      icon = _ref.icon,
      hover = _ref.hover,
      props = _objectWithoutProperties(_ref, _excluded);

  var width, height, fontSize;

  switch (size) {
    case "tiny":
      width = fullWidth ? "100%" : "70px";
      height = "24px";
      fontSize = "11px";
      weight = "normal";
      break;

    case "extra-small":
      width = fullWidth ? "100%" : "auto";
      height = "24px";
      fontSize = "13px";
      weight = "normal";
      break;

    case "small":
      width = fullWidth ? "100%" : "auto";
      height = "32px";
      fontSize = "16px";
      weight = variant === "secondary" ? "normal" : "bold";
      break;

    case "medium":
      width = fullWidth ? "100%" : "auto";
      height = "42px";
      fontSize = "16px";
      weight = "bold";
      break;

    case "large":
      width = fullWidth ? "100%" : "auto";
      height = "50px";
      fontSize = "16px";
      weight = "bold";
      break;
  }

  switch (variant) {
    case "primary":
      return /*#__PURE__*/React.createElement(Primary, _extends({
        role: "button",
        weight: weight,
        fontSize: fontSize,
        uppercase: uppercase,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        width: width,
        transparent: transparent,
        height: height,
        hover: hover,
        borderRadius: borderRadius
      }, props), isLoading ? /*#__PURE__*/React.createElement("img", {
        className: "",
        src: require("@uprise/core/assets/images/animated/ellipsis-white.svg")
      }) : /*#__PURE__*/React.createElement("span", null, title));

    case "secondary":
      return /*#__PURE__*/React.createElement(Secondary, _extends({
        role: "button",
        weight: weight,
        fontSize: fontSize,
        uppercase: uppercase,
        transparent: transparent,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        borderRadius: borderRadius,
        width: width,
        height: height,
        hover: hover
      }, props), isLoading ? /*#__PURE__*/React.createElement("img", {
        className: "",
        src: require("@uprise/core/assets/images/animated/ellipsis-white.svg")
      }) : /*#__PURE__*/React.createElement("span", null, title));

    case "tertiary":
      return /*#__PURE__*/React.createElement(Tertiary, _extends({
        role: "button",
        weight: weight,
        fontSize: fontSize,
        uppercase: uppercase,
        paddingLeft: paddingLeft,
        transparent: transparent,
        paddingRight: paddingRight,
        borderRadius: borderRadius,
        width: width,
        height: height,
        hover: hover
      }, props), isLoading ? /*#__PURE__*/React.createElement("img", {
        className: "",
        src: require("@uprise/core/assets/images/animated/ellipsis-white.svg")
      }) : /*#__PURE__*/React.createElement("span", null, title));

    case "text":
      return /*#__PURE__*/React.createElement(TextButton, _extends({
        role: "button",
        weight: weight,
        uppercase: uppercase,
        fontSize: fontSize,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        borderRadius: borderRadius,
        width: width,
        height: height,
        hover: hover
      }, props), isLoading ? /*#__PURE__*/React.createElement("img", {
        className: "",
        src: require("@uprise/core/assets/images/animated/ellipsis-white.svg")
      }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, title), icon && /*#__PURE__*/React.createElement(IconRight, {
        src: Icons.chevronRightPurple
      })));
  }
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

Button.propTypes = {
  variant: string.isRequired,
  className: string,
  title: string.isRequired,
  size: string,
  fullWidth: bool,
  disabled: bool,
  isPressed: bool,
  isLoading: bool,
  onClick: func,
  hover: bool
};
Button.defaultProps = {
  variant: "primary",
  className: "",
  title: "",
  size: "large",
  hover: true,
  fullWidth: true,
  icon: false,
  isLoading: false,
  disabled: false,
  isPressed: false
};